import io from "socket.io-client";

const hasValue = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "";

class SocketWorker {
  constructor(companyId, userId) {
    const nextCompanyId = companyId;
    const nextUserId = userId;

    if (SocketWorker.instance) {
      const inst = SocketWorker.instance;
      const changed =
        String(inst.companyId || "") !== String(nextCompanyId || "") ||
        String(inst.userId || "") !== String(nextUserId || "");

      const hasNextIds = hasValue(nextCompanyId) && hasValue(nextUserId);

      // If identity changed (logout/login, switch company), reconnect with correct auth.
      if (hasNextIds && changed) {
        inst.disconnect();
      } else {
        return inst;
      }
    }

    this.companyId = nextCompanyId;
    this.userId = nextUserId;
    this.socket = null;
    this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
    this.configureSocket();
    SocketWorker.instance = this;

    return SocketWorker.instance;
  }

  configureSocket() {
    const auth = hasValue(this.userId) && hasValue(this.companyId)
      ? { user_id: this.userId, company_id: this.companyId }
      : undefined;
    const query = hasValue(this.userId) ? { userId: this.userId } : {};

    // Connect to default namespace ("/"). Backend emits company-scoped events by name
    // and may reject dynamic namespaces like "/{companyId}".
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}`, {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      transports: ["polling"],  // DATXALE_FIX_20260521 - Force polling (OLS does not support WS upgrade)
      upgrade: false,           // Prevent upgrade attempts that cause disconnect loops
      // Backend expects auth payload (python-socketio connect handler); query is legacy fallback.
      auth,
      query,
    });

    this.socket.on("disconnect", () => {
      this.reconnectAfterDelay();
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {
    this.connect();
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    this.connect();
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      try {
        this.socket.removeAllListeners();
      } catch (_) { }
      this.socket.disconnect();
    }
    this.socket = null;
    this.eventListeners = {};
    SocketWorker.instance = null;
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
      return;
    }

    if (this.socket && !this.socket.connected) {
      try {
        // Ensure latest auth is applied before reconnect.
        this.socket.auth = { user_id: this.userId, company_id: this.companyId };
      } catch (_) { }
      try {
        this.socket.connect();
      } catch (_) { }
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;
